export default {
    quick: 'search/quick',
    global: 'search/global'
}